import axios from '../helpers/axios'
import { logError } from '../services';
import { IResponse, ISiteReport } from '../models';

export const getSiteReports = async (
  neighborhoodId: number | string,
  filters?: {
    page?: number;
    perPage?: number | string;
    sortBy?: string;
    sortDirection?: string;
    jobStatus?: string | null;
    jobType?: string | null;
    isActive?: boolean;
  }
): Promise<IResponse<ISiteReport[]>> => {
  try {
    const { data } = await axios.get(`/api/neighborhoods/${neighborhoodId}/site-reports`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getSiteReports failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSitePrepReport = async (jobId: string | number): Promise<any> => {
  try {
    const { data } = await axios.get(`/api/jobs/${jobId}/reports/site-prep`, {
      responseType: 'blob'
    });
    return data;
  } catch (error) {
    logError(error, 'getSitePrepReport failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSitePlanningReport = async (jobId: string | number): Promise<any> => {
  try {
    const { data } = await axios.get(`/api/jobs/${jobId}/reports/site-planning`, {
      responseType: 'blob'
    });
    return data;
  } catch (error) {
    logError(error, 'getSitePlanningReport failed');
    return Promise.reject(error?.response?.data);
  }
};
